import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/tpa-settings/react';
import React from 'react';
import { Divider, Text } from 'wix-ui-tpa/cssVars';
import { DaySectionViewModel } from '../../../../components/DailyAgenda/viewModel/agendaViewModel/agendaViewModel';
import { LayoutTypes } from '../../../../types/types';
import { AgendaItem } from './AgendaItem/AgendaItem';
import { classes, st } from './DaySection.st.css';
import Sticky from 'react-sticky-el';
import { useDatePicker } from '../../../../components/DailyAgenda/hooks/useDatePicker';
import settingsParams from '../../../../components/DailyAgenda/settingsParams';

export const DaySection: React.FC<DaySectionViewModel> = ({
  _dateISO,
  date,
  splittedDate,
  agendaItems,
}) => {
  const { isMobile } = useEnvironment();
  const settings = useSettings();
  const sectionId = splittedDate.date.replaceAll(' ', '-');
  const { setCurrentDate, headerSize } = useDatePicker();
  const layoutType = settings.get(settingsParams.layoutStyle) as LayoutTypes;
  const isHeaderSticky = settings.get(settingsParams.headerSticky);
  let headerScrollHeight = 0;
  let headerElementOffset = 0;

  if (isHeaderSticky) {
    headerScrollHeight = headerSize?.height || 0;
    headerElementOffset = isMobile ? 0 : 16;
  }

  const renderDate = () => {
    if (isMobile) {
      return <Text className={classes.date}>{date}</Text>;
    }

    return (
      <>
        <Text className={classes.splittedDate}>{splittedDate.date}</Text>
        <Text className={classes.splittedDay}>{splittedDate.day}</Text>
      </>
    );
  };

  return (
    <section
      className={st(classes.root, { layoutType, isMobile })}
      id={sectionId}
    >
      <Sticky
        boundaryElement={`#${sectionId}`}
        topOffset={-headerScrollHeight - headerElementOffset}
        bottomOffset={-headerScrollHeight - headerElementOffset}
        onFixedToggle={(state) => {
          if (state) {
            setCurrentDate(new Date(_dateISO));
          }
        }}
      />
      <div
        className={st(classes.dateContainer, classes.listItem)}
        style={{ top: `${headerScrollHeight + headerElementOffset}px` }}
        role="presentation"
      >
        {renderDate()}
      </div>
      <ul className={classes.slotList}>
        {agendaItems.map((agendaItemViewModel, index) => (
          <li
            className={classes.slotContainer}
            key={agendaItemViewModel.slotId}
          >
            <AgendaItem
              layoutType={layoutType}
              agendaItemViewModel={agendaItemViewModel}
            />
            <Divider className={classes.agendaItemDivider} />
          </li>
        ))}
      </ul>
    </section>
  );
};
